import { render, staticRenderFns } from "./ProposalModal.vue?vue&type=template&id=bf79b970"
import script from "./ProposalModal.vue?vue&type=script&lang=js"
export * from "./ProposalModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports